<template>
  <div class="navMenu">
    <template v-for="navMenu in navMenus">
      <!-- 最后一级菜单 -->
      <el-menu-item
        v-if="!navMenu.children || !navMenu.children.length"
        :key="navMenu.url"
        :data="navMenu"
        @click="routerLink(navMenu.url)"
        :index="navMenu.url"
      >
        <i v-if="navMenu.icon" class="icon" :class="navMenu.icon" />
        <!-- <i v-if="navMenu.icon" :class="navMenu.icon"></i> -->
        <span v-else class="iconspan"></span>
        <span slot="title">{{ navMenu.name }}</span>
      </el-menu-item>

      <!-- 此菜单下还有子菜单 -->
      <el-submenu
        v-if="navMenu.children && navMenu.children.length"
        :key="navMenu.url"
        :data="navMenu"
        :index="navMenu.url"
        @click="routerLink(navMenu.url)"
      >
        <template slot="title">
          <!-- <img v-if="navMenu.icon" class="icon" :src="require(`assets/images/${navMenu.icon}`)"> -->
          <!-- <span v-else class="iconspan"></span> -->
          <i v-if="navMenu.icon" class="icon" :class="navMenu.icon" />

          <!-- <i :class="navMenu.icon"></i> -->
          <span>{{ navMenu.name }}</span>
        </template>
        <!-- 递归 -->
        <NavMenu :navMenus="navMenu.children"></NavMenu>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: "NavMenu",
  props: ["navMenus"],
  data() {
    return {};
  },
  methods: {
    routerLink(url) {
      if (!url) return;
      if (url.includes("http")) {
        window.open(url);
        // location.href = url;
        return;
      }
      this.$router.push(url);
    },

    getUrl(url) {
      if (url.includes("?")) return url.split("?")[0];
      else return url;
    },
  },
};
</script>

<style scoped>
.icon {
  margin: 1px 10px 0px 13px;
  width: 18px;
  display: inline-block;
  opacity: 0.5;
  color: #000 ;
}
.iconspan {
  margin: 0px 5px 0px 13px;
  width: 5px;
  display: inline-block;
}
.is-active .icon {
  opacity: 1 !important;
}
</style>